
<template>
<v-card class="transparent" flat width="100%" height="100%" style="padding-bottom:50px;">

    <v-snackbar v-model="snackbar" :timeout="4000" top color="success">
      <span>Awesome! You updated the Blog.</span>
      <v-btn color="white" text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-layout justify-center>
    <v-flex xs12 s12 m10 lg10>
    <v-card-title class="title font-weight-regular justify-space-between">
          <span>Edit Blog</span>
          <v-avatar
            size="45"
          >
          <v-img  v-if="UserRecord.Profile_Photo" :src="UserRecord.Profile_Photo">
          </v-img>
          <v-img v-if="!UserRecord.Profile_Photo" src="@/assets/BlankProfilePic.png">
          </v-img>
          </v-avatar>
        </v-card-title>
        <v-card-subtitle>
          {{UserRecord.Full_Name}}
        </v-card-subtitle>
        <v-layout class="justify-center">
        <v-card flat outlined light width="90%" class="my-3">
            <v-card-text>
              
                <v-text-field label="Title" v-model="BlogTitle">
                </v-text-field>     
                 <v-combobox return-object item-text="Name"
                  chips v-model="Category" :items="BlogsCategories" label="Category" >
                </v-combobox>         
                 <UserLookup v-if="$store.state.TemplateView" :UsersLookupArray="TemplateUsers"  :ModelProp="'Creator'" :RecordObj="editedItem" @UpdateUserLookupProp="UpdateUserLookupProp"
                    :FieldLabel="'Author'" :Rules="[$store.state.formrules.required]"
                    />        
                <v-switch v-if="!$store.state.UserisGuest && System.Guests_can_Social || System.Guests_can_Social && GroupData" v-model="TempGuestsIncluded"  :label="GroupData ? 'Include Non Team Members' : 'Include Guest Users'"/>
                <v-menu
                        v-model="PublishDatemenu"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="290px"
                        id="PublishDate">
                        <template v-slot:activator="{ on }">
                          <v-text-field                            
                            v-model="PublishDate"
                            label="Publish Date"
                            prepend-icon="mdi-calendar-month"
                            readonly
                            v-on="on"
                            id="PublishDate"
                          ></v-text-field>
                        </template>
                        <v-date-picker v-model="PublishDate" @input="PublishDatemenu = false"></v-date-picker>
                      </v-menu>
                <v-checkbox label="Is Image Shy" v-model="ImageShy"/>
                <input
                v-if="!ImageShy && !$store.state.TemplateView"
            type="file"
            @change="onblogcoverimageselect($event)"
            ref="coverimageinputter">
           
                </v-card-text>
                <v-layout class="justify-center">
                
          <v-img v-if="coverimagelocalurl && !$store.state.TemplateView" :src="coverimagelocalurl">
          </v-img>
                <v-img class="black" height="200" contain	v-if="$store.state.TemplateView"								
                    :src="coverimage ? coverimage : require('@/assets/ImageHolder.png')"									
                    >
                    <v-row style="left: 12px;position: absolute; bottom: 40px;width: 100%;height:50px;padding-top:10px;background: linear-gradient(180deg, rgba(222,221,221,0.5) 0%, rgba(222,221,221,0.5) 100%);">
                
                        <v-chip style="cursor: pointer;"  @click="ActivateGalleryDialog('SampleSiteBlogCoverIMG')" :class="$vuetify.theme.dark ? 'mx-3' : 'white mx-3'">Change</v-chip>
                    </v-row>
              </v-img>
                </v-layout>
          <v-card-text>
              <ContentEditable @ActivateTagLinkDialog="ActivateTagLinkDialog"/>
            </v-card-text>
            <v-card-actions>    
            <v-textarea label="Caption" v-model="Caption" :rules="[$store.state.formrules.max150Chars]" />
            </v-card-actions>
            <v-card-actions>                
                <v-select multiple :items="SiteModerators" item-text="Full_Name" v-model="Moderators" return-object label="Select Moderators"/>                
            </v-card-actions>
            <v-card-actions>
                  <v-spacer></v-spacer>
                <v-btn @click="CancelEdit()" outlined color="orange">
                    Cancel
                </v-btn>
                <v-btn outlined color="green" @click="StoreBlog()">
                    Save
                </v-btn>
                <!-- <v-card-actions v-if="!$store.state.TemplateView">
              <TaggingComponent @SaveSingleTag="SaveSingleTag" :AppisDarkModeCard="AppisDarkModeCard" :record="FullArticleData" :TagLinkDialog="TagLinkDialog" />
            </v-card-actions> -->
            </v-card-actions>
        </v-card>
        </v-layout>
   
    
   </v-flex>
</v-layout>
</v-card>
</template>


<script>
import firebase from 'firebase';
import db from '@/main'
import format from 'date-fns/format'
import axios from 'axios'
import TaggingComponent from '@/components/SocialNetwork/TaggingComponent';
import ContentEditable from '@/components/SocialNetwork/ContentEditable';
import UserLookup from '@/components/General/UserLookup'
// import 'quill/dist/quill.core.css'
// import 'quill/dist/quill.snow.css'
// import 'quill/dist/quill.bubble.css'

// import { quillEditor } from 'vue-quill-editor'

export default {
    props: ['caption','title','pubdatastring','CurrentImageShy','Currentblogcontent','CurrentModerators','GuestsIncluded','GroupData'
    ,'SiteModerators','CurrentImage','CurrentImageThumb','FullArticleData'],
        middleware: 'auth',
      components: {
        TaggingComponent,
        ContentEditable,
        UserLookup
    // quillEditor

        
  },
  
    data() {
        return {
          coverimage: '',
          Category: '',
          ItemCategory: '',
          TempGuestsIncluded: false,
          TagLinkDialog: false,
          UsersArray: [],
          Caption: '',
          Moderators: [],
          PublishDate: '',
          PublishDatemenu: false,
          BlogTitle: '',
          ImageShy: false,
        selectedFile: '',
        ImagelocalURL: '',
        BlogContent: '',
        blogquil: false,
        snackbar: false,
            // content: '<h2>I am Example</h2>',
        editorOption: {
          // some quill options
        },
        blogdialog: false,
                    inputRules: [
            v => !!v || 'This field is required',
            v => v.length >= 3 || 'Minimum length is 3 characters'
      ],
      UserRecord: {},
      blogtitle: null,
        blogcontent: '',
        author: '',
        authorid: '',
        // userid: this.$store.state.user.id,
        groupblogs: [],
        groups: [],
        blogid: this.$route.params.id,
        content: null,
        selectedcoverimage: '',
        coverimagelocalurl: '',
        image: '',
        Youtubelink: '',
        HasImage: false,
        rules: {
          max150Chars: value => value.length < 151 || "Max. 150 characters",
        youtubeurl: value => {
            const pattern = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=|\?v=)([^#\&\?]*).*/;
            return pattern.test(value) || "Not a Youtube Video Link.";
          },
          min8Chars: value => value.length >= 8 || "Min. 8 characters",
          required: value => !!value || "Required.",
          email: value => {
            const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return pattern.test(value) || "Invalid e-mail.";
          },
          url: value => {
            const urlpattern = new RegExp('^(https?:\\/\\/)?'+ // protocol
          '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.?)+[a-z]{2,}|'+ // domain name
          '((\\d{1,3}\\.){3}\\d{1,3}))'+ // OR ip (v4) address
          '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*'+ // port and path
          '(\\?[;&a-z\\d%_.~+=-]*)?'+ // query string
          '(\\#[-a-z\\d_]*)?$','i'); 
            return urlpattern.test(value) || "Invalid Link.";
          }
        },
       
            editedItem: {
                Name: null,
                description: null,
                url: null,
                logo: null,                
            },
            defaultItem: {
                Name: null,
                description: null,
                url: null,
                logo: null,                
            },
            BlogsCategories: []
        }
    },
    computed: {
        groupid(){
          return this.$route.params.id && !this.$store.state.TemplateView ? this.$route.params.id : ''
        },
      TemplateUsers(){
        return this.ActiveMarketTemplate && this.ActiveMarketTemplate.Users ? this.ActiveSuiteTemplate.Users.concat([this.userLoggedIn]) :
        this.ActiveSuiteTemplate && this.ActiveSuiteTemplate.Users ? this.ActiveSuiteTemplate.Users.concat([this.userLoggedIn]) : [this.userLoggedIn]
      },
      SelectedImage(){
        return this.$store.state.SelectedGalleryAsset
      },  
      SuiteSocialNetwork(){
            return this.ActiveSuiteTemplate ? this.ActiveSuiteTemplate.SocialNetwork : ''
        },
      RouteName(){
          return this.$route.name === 'GroupBlog' || this.$route.name === 'MarketplaceTemplateGroupSingle' || this.$route.name === 'SuiteTemplateGroupSingle' ? this.GroupData.name+' Blogs' : 
          this.SuiteSocialNetwork ? this.SuiteSocialNetwork.Name :
          this.ActiveMarketTemplate && this.ActiveMarketTemplate.TemplateProps && this.ActiveMarketTemplate.TemplateProps.Name ? this.ActiveMarketTemplate.TemplateProps.Name :
          this.System.Name
        },
      UserisTemplateOwner(){
        return this.$store.state.TemplateOwner
      }, 
      ActiveMarketTemplate(){
        return this.$store.state.TemplateView
      },
      ActiveSuiteTemplate(){
          return this.$store.state.ActiveSuiteTemplate
      },
      ContentCategoriesPath(){
        return this.$route.name === 'GroupBlogSingle' ? this.ContentRootPath.collection('groups').doc(this.$route.params.id).collection('BlogsCategories') : 
        this.ContentRootPath.collection('BlogsCategories')
      },
      ContentRootPath(){
        return this.$store.state.TemplateView ? this.TemplateRootPath : db.collection('SocialNetworks').doc(this.$store.state.ActiveSuiteid)
      },
      ContentColPath(){
        //quick tip here. Edit and New components reuqire collection to update, or add docs. thus, not interchangeable with CollectionRef on "feed" or "collection view"
        //the CollectionRef would add permission queries like for group aticles "where gourpid...etc"
        return this.$store.state.TemplateView ? this.ContentRootPath.collection('samplesiteblogs') : 
        this.$route.name === 'GroupBlogSingle' ? this.ContentRootPath.collection('groupblogs') : this.ContentRootPath.collection('siteblogs')
      },
      TemplateRootPath(){
        return this.ActiveSuiteTemplate ? db.collection('SocialNetworks').doc(this.ActiveSuiteTemplate.id) :
        this.ActiveMarketTemplate ? db.collection('marketplacetemplates').doc(this.ActiveMarketTemplate.id) : ''
      },
      SocialItemInteractMethod(){
      return this.$store.state.SocialItemInteractMethod
      },
      SocialItemInteractMethodProp(){
        return this.$store.state.SocialItemInteractMethodProp
      },
        System(){
          return this.$store.state.SystemObj
        },
        userLoggedIn () {
          return this.$store.getters.user
        },
        ModeratorsIDStrings(){
          return this.Moderators.map(mod => {
            mod.id
          })
        },
        RelatedBlogs () {
            return this.groupblogs.filter(blog => {
                return blog.blogid === this.blogid
            })
        },
      //         editor() {
      //   return this.$refs.myQuillEditor.quill
      // }
    },
    watch: {
        SocialItemInteractMethod(v){   
        let acceptedmethods = ['AssignSampleSiteBlogCoverIMG']   
        if(v && acceptedmethods.includes(v)){
          if(this.SocialItemInteractMethodProp){
            this[this.SocialItemInteractMethod](this.SocialItemInteractMethodProp)
            if(this.SocialItemInteractMethod === 'ActivateSelectedElement'){
              this.SingleRecordNavMenuItem = ''
            }
            this.$store.commit('SetSocialItemInteractMethodProp','') 
            this.$store.commit('SetSocialItemInteractMethod','')
          }
          else{ 
            this[this.SocialItemInteractMethod]()
            this.$store.commit('SetSocialItemInteractMethodProp','') 
            this.$store.commit('SetSocialItemInteractMethod','')
          }          
        }
      },
    },
    created() {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
      this.UserRecord = this.userLoggedIn
      this.authorid = this.UserRecord.id
      this.author = this.UserRecord.Full_Name
      if(this.$store.state.TemplateView){
        this.UserRecord = Object.assign({},this.userLoggedIn)
        this.GetSiteBlogsCategories()
      }
      else if(this.$route.name !== 'GroupMeetup'){
        this.BlogsCategories = this.System.BlogsCategories
      }
      else{
        this.BlogsCategories = this.GroupData.BlogsCategories
      }
      this.GetProperties()
    },
    
    methods: {
      UpdateUserLookupProp(Prop,Value,RecordObj){
            RecordObj[Prop] = Value
        },
      GetSiteBlogsCategories(){
        this.ContentCategoriesPath.onSnapshot(res => {
            const changes = res.docChanges();
              changes.forEach(change => {
                if (change.type === 'added') {
                  this.BlogsCategories.push({
                    ...change.doc.data(),
                    id: change.doc.id
                  })
                }
              })
          })
      },
      ActivateGalleryDialog(prp){
        this.$store.commit('SetSocialItemInteractMethod','ToggleGalleryDialog')
        this.$store.commit('setIMGProp',prp)
      },
      AssignSampleSiteBlogCoverIMG(){
        this.coverimage = this.SelectedImage.fileurl
       //this.RefreshDialog()
        this.$store.commit('setIMGProp','')
      },
      ActivateTagLinkDialog(boolean){
        this.TagLinkDialog = boolean  
      },
      taglink(){
        this.TagLinkDialog = true
      },
      SaveSingleTag(tagitem){
        //console.log(tagitem)
        this.TagLinkDialog = false  
        document.execCommand("createLink", false, tagitem.taglocation);
      },
        CancelEdit(){
            this.$emit('StopEdit')
        },
        GetProperties(){
          if(this.FullArticleData.Category){
            this.Category = this.FullArticleData.Category
            this.ItemCategory = this.FullArticleData.Category
          }
          
          if(this.FullArticleData.coverimage){
            this.coverimage = this.FullArticleData.coverimage
          }
          this.TempGuestsIncluded = this.GuestsIncluded
            this.BlogTitle = this.title
            this.PublishDate = this.pubdatastring
            //console.log(this.PublishDate)
            this.ImageShy = this.CurrentImageShy
            if(this.CurrentImage){
              this.coverimagelocalurl = this.CurrentImage
              this.HasImage = true
            }
            if(this.caption){
              this.Caption = this.caption
            }
            if(this.FullArticleData.Creator){
              this.editedItem.Creator = this.FullArticleData.Creator
            }
            // console.log(this.SiteModerators)
            // console.log(this.SiteModerators)
            this.Moderators = this.CurrentModerators.map(moderator => {
                let fullobj = this.SiteModerators.find(obj => obj.id === moderator)
                return fullobj
            }).filter(mod => {
              return mod && mod.id
            })
            let Moderator = {
              Full_Name: this.userLoggedIn.Full_Name,
              Name: this.userLoggedIn.Name,
              Surname: this.userLoggedIn.Surname,
              ModerationPermissions: this.userLoggedIn.ModerationPermissions ? this.userLoggedIn.ModerationPermissions : [],
              id: this.userLoggedIn.id
            }
            if(!this.Moderators.find(obj => obj.id === Moderator.id)){
               this.Moderators.push(Moderator)
            }
            let elementid = 'NewBlogValue'            
            setTimeout(() => {
                let blogcontentelmnt = document.getElementById(elementid)
                blogcontentelmnt.innerHTML = this.Currentblogcontent
            }, 300);
            
        },
      
   DateFormatter(date){
      if(date){
      let yearstring = date.split('-')[0]
        let monthstring = date.split('-')[1]
        let daystring = date.split('-')[2]
        let yearnumber = Number(yearstring)
        let monthnumber = Number(monthstring)
        let daynumber = Number(daystring)
        return new Date(yearnumber, monthnumber-1, daynumber)
        }
      else{
        return null
      }
   },
        onblogcoverimageselect(event) {
      this.selectedcoverimage = event.target.files[0]
      this.HasImage = false
      this.coverimagelocalurl = URL.createObjectURL(this.selectedcoverimage)
    },
        StoreBlog(){
          let Creator = {Full_Name: this.UserRecord.Full_Name,id: this.UserRecord.id,Name: this.UserRecord.Name,Surname: this.UserRecord.Surname}
            let MaskedUser = ''
            if(this.$store.state.TemplateView && this.editedItem.Creator){
              Creator = {Full_Name: this.editedItem.Creator.Full_Name,id: this.editedItem.Creator.id,Name: this.editedItem.Creator.Name,Surname: this.editedItem.Creator.Surname}
              MaskedUser = {Full_Name: this.UserRecord.Full_Name,id: this.UserRecord.id,Name: this.UserRecord.Name,Surname: this.UserRecord.Surname}
            }
          let vm = this
          vm.$emit('ActivateProcessing',true)
           if(vm.Category && !vm.Category.ID){
            let length = vm.BlogsCategories.length
            let int = 1000001+length
            let newcat = {
              ID: int,
              Name: vm.Category
            }
            vm.ItemCategory = newcat
            this.ContentCategoriesPath.add(newcat)
          }
          else if(vm.Category && vm.Category.ID){
            vm.ItemCategory = vm.Category
          }
          let routepath = ''
          let routeprop = ''
          let storagepath = ''
          let docid = this.$route.params.id
          if(this.ActiveMarketTemplate){
              routepath = '/MarketplaceTemplate/'+this.$route.params.id+'/Blog/'
              routeprop = 'id'
              docid = this.$route.params.slug
            }
          else if(this.ActiveSuiteTemplate){
              routepath = '/Your-Domain/'+this.$route.params.id+'/Social-Network/Blog/'
              routeprop = 'id'
              docid = this.$route.params.slug
            }
          else if(this.$route.name === 'GroupBlog'){
            routepath = '/Group-Blog/'+this.$route.params.id+'/Blog/'
            routeprop = 'title'
            docid = this.$route.params.slug
          }
          else{
            routepath = '/Blog/'
            routeprop = 'id'
          }
        let postelmnt = document.getElementById('NewBlogValue')
        //console.log(postelmnt)
        let postinput = postelmnt.innerHTML
        let ModeratorRolesObject = {}
        let ModeratorRolesArray= []
        this.Moderators.map(mod => {
          ModeratorRolesObject[mod.id] = true
          ModeratorRolesArray.push(mod.id)
        })
        let NewBlog = {
          caption: this.Caption,
          Likes: [],
          Shares: [],
          tags: [],
          title: this.BlogTitle,
          Creator: {Full_Name: Creator.Full_Name,id: Creator.id},          
          Creatorid: Creator.id,
          author: Creator.Full_Name,
          authorid: Creator.id,
          description: postinput,
          createdon: new Date(),
          PublishDate: this.DateFormatter(this.PublishDate),
          Comments: [],
          ImageShy: this.ImageShy,
          PublishStatus: 'Draft',
          Moderators: this.Moderators,
          moderatorrolesarrayDBRules: ModeratorRolesObject,
          moderatorrolesarrayQuery: ModeratorRolesArray,
          GuestsIncluded: this.TempGuestsIncluded
        }   
        if(this.groupid){
          NewBlog.groupid = this.groupid
        }   
        
        if(!NewBlog.groupid && this.userLoggedIn && this.userLoggedIn.Company){
          NewBlog.Company = this.userLoggedIn.Company
          NewBlog.Companyid = this.userLoggedIn.Companyid
        }  
        if(vm.ItemCategory){
          NewBlog.Category = vm.ItemCategory
        }
        if(Creator.Profile_Photo){
          NewBlog.creatorimg = Creator.Profile_Photo
        } 
        
        this.$store.dispatch('CreateSearchTitle',NewBlog.title).then(searchtitle => {
        NewBlog.titleQuery = searchtitle
        let docref = this.ContentColPath.doc(docid)
            if(this.selectedcoverimage && this.BlogTitle && postinput && !this.$store.state.TemplateView){
            if(this.HasImage === false){
              if(this.$route.name === 'GroupBlog'){
                storagepath = 'GroupBlogs/'+this.$route.params.id+'/CoverImage/'+new Date()+'/'+this.selectedcoverimage
              }
              else{
                storagepath = 'SiteBlogs/'+this.$route.params.id+'/CoverImage/'+new Date()+'/'+this.selectedcoverimage
              }
              this.UpdateBlogCoverImage(this.selectedcoverimage,storagepath).then(function(result) {
                if(result){
                    NewBlog.coverimage = result
                    NewBlog.CoverStorageRef = storagepath
                  docref.set(NewBlog).then(doc => {
                      vm.$emit('StopEdit')
                  })
                  console.log(NewBlog.post)
                    vm.CancelNewBlogDialog()
                    
                }          
              })
            }
            else{
              NewBlog.coverimage = this.CurrentImage
              //NewBlog.coverimageThumbURL = this.CurrentImageThumb
              docref.set(NewBlog).then(doc => {
                      vm.$emit('StopEdit')
                  })
            }
              
            }
            else if(this.ImageShy && this.BlogTitle && postinput || this.$store.state.TemplateView){
                
            
              if(this.$store.state.TemplateView){
                NewBlog.coverimage = this.coverimage
                NewBlog.PublishDate = new Date()
              }
              
          
                  docref.set(NewBlog).then(doc => {
                vm.CancelEdit()
                  })
              
                  //console.log(NewBlog.post)          
            }
            else if(!this.selectedcoverimage && this.BlogTitle && postinput && this.HasImage === false){
                alert('You have to upload an image')
            }
            else if(!this.selectedcoverimage && !this.BlogTitle && postinput && this.HasImage === false){
                alert('You have to upload an image, and insert a title')
            }
            else if(!this.selectedcoverimage && !this.BlogTitle && !postinput){
                alert('There is nothing to post!')
            }
            else if(!this.selectedcoverimage && this.BlogTitle && !postinput){
                alert('There is no cover image, or post content!')
            }
            else if(this.selectedcoverimage && !this.BlogTitle && postinput){
                alert('You have to insert a title')
            }
            else if(this.selectedcoverimage && !this.BlogTitle && !postinput){
                alert('You have to insert a title, and content')
            }
            else if(this.selectedcoverimage && this.BlogTitle && !postinput){
                alert('You have to insert content')
            }
        })
        
      
        },

        UpdateBlogCoverImage(picturefile,storagepath){
      let vm = this
      return new Promise(function(resolve, reject) {
      var storageRef = firebase.storage().ref(storagepath);
      var uploadTask = storageRef.put(picturefile);
      uploadTask
      .then(snapshot => snapshot.ref.getDownloadURL())
        .then((url) => {
          
          
          resolve(url)
              })
                
      })
    },
        CancelNewBlogDialog(){
            this.BlogTitle = ''
            this.selectedcoverimage = ''
        },
      IntranetViewToggle(){
        this.$emit('IntranetViewToggle',true)
      },
      FocusedViewToggle(){
        this.$emit('FocusedViewToggle',false)
      },
            getUserInformation() {
                db.collection('SystemConfig').doc(this.$store.state.ActiveSuiteid).collection('users').doc(this.UserRecord.id).onSnapshot(snapshot => {
          // this.UpdateRequestStatus()
          var userdata = snapshot.data()
        this.authorid = userdata.id
      
        this.author = userdata.Name+' '+userdata.Surname
        //console.log('this is user name man '+this.author)
      

        })
            },
          
      }
      
    }
// }
</script>
<style>
.tabsinner {
    background-color: #f8f8f8;
    color: #575757;
}
.Grouptitle {
color: #048abf;
margin-left: 0.5em
}
.Groupdescription {
color: #70cbf3;

}
.Image {

margin-left: 0.5em
}
h2{
  color: 'primary';
}
    
</style>